export const requiredFieldValidationMessage = (fieldName: string) =>
  `Please provide a ${fieldName}`;
